import * as types from '../../configs/constants/actionType'
import generateActions from '../actions/actions'

const eaiLicenseReducer = (state: any = {}, action: any) => {
  switch (action.type) {
    case generateActions(types.EAI_LICENSE_LIST).REQUEST:
      return Object.assign({}, state, { rows: [] }, { isLoading: true })
    case generateActions(types.EAI_LICENSE_LIST).SUCCESS:
      return Object.assign({}, state, action.payload, { isLoading: false })
    case generateActions(types.EAI_LICENSE_LIST).FAILURE:
      return Object.assign({}, state, { isLoading: false })

    case generateActions(types.EAI_LICENSE_DROPDOWN).REQUEST:
      return Object.assign({}, state, {
        usbSn: null
      })
    case generateActions(types.EAI_LICENSE_DROPDOWN).SUCCESS:
      return Object.assign({}, state, action.payload)

    case generateActions(types.EAI_LICENSE_IMPORT).REQUEST:
      return Object.assign({}, state, { isLoadingAPI: true })
    case generateActions(types.EAI_LICENSE_IMPORT).SUCCESS:
      return Object.assign({}, state, action.payload, { isLoadingAPI: false })
    case generateActions(types.EAI_LICENSE_IMPORT).FAILURE:
      return Object.assign({}, state, action.payload, { isLoadingAPI: false })

    case generateActions(types.DEACTIVATE_EAI_LICENSE).REQUEST:
      return Object.assign({}, state, { isLoadingAPI: true })
    case generateActions(types.DEACTIVATE_EAI_LICENSE).SUCCESS:
      return Object.assign({}, state, action.payload, { isLoadingAPI: false })
    case generateActions(types.DEACTIVATE_EAI_LICENSE).FAILURE:
      return Object.assign({}, state, action.payload, { isLoadingAPI: false })

    case generateActions(types.SYNC_EAI_LICENSE).REQUEST:
      return Object.assign({}, state, { isLoadingAPI: true })
    case generateActions(types.SYNC_EAI_LICENSE).SUCCESS:
      return Object.assign({}, state, action.payload, { isLoadingAPI: false })
    case generateActions(types.SYNC_EAI_LICENSE).FAILURE:
      return Object.assign({}, state, action.payload, { isLoadingAPI: false })

    case generateActions(types.CLEAR_ERROR_EAI).REQUEST:
      return Object.assign({}, state, { responseStatus: null })

    default:
      return state
  }
}

export default eaiLicenseReducer
